<ul class="d-flex unlist-group ml-3">
  <li class="nav-item" *ngFor="let menu of headerMenus | orderBy: 'order' | filterByRole">
    <app-header-menu-item [item]="menu"></app-header-menu-item>
    <ul class="shared-abs-element unlist-group shared-box-shadow no-radius-top-lr" *ngIf="menu.child">
      <li class="nav-item" *ngFor="let subMenu of menu.child | filterByRole">
        <app-header-menu-item [item]="subMenu"></app-header-menu-item>
      </li>
    </ul>
  </li>
</ul>